import PropTypes from 'prop-types'
import TlBanksApiV2 from 'api/v2/admins/tl-banks-api-v2'
import { SelectSearchField } from 'components'
import { useFormikContext } from 'formik'
import React, { useState } from 'react'

const propTypes = {
  name            : PropTypes.string,
  label           : PropTypes.string,
  required        : PropTypes.bool,
  showRole        : PropTypes.bool,
  showDescription : PropTypes.bool
}

const defaultProps = {
  showRole        : true,
  showDescription : false
}

/**
 * Search field to select warehouse location by its name
 * @param {Boolean} showDescription - show description in option label
 * @param {Object} props - props object
 */
const TlBankSelectSearchField = ({
  name,
  label,
  required,
  showRole,
  showDescription,
  ...props
}) => {
  const [ tlBanks, setTlBanks ]            = useState([])
  const [ isLoading, setIsLoading ]        = useState(true)
  const { setFieldError, setFieldTouched } = useFormikContext()

  var searchTimeout = null

  // search TlBanks by bank name
  const getTlBanks = (searchText) => {
    setIsLoading(true)

    const filterParams = {}

    if (Number.isInteger(parseInt(searchText))){
      filterParams['account_number'] = searchText
    }
    else {
      filterParams['bank'] = searchText
    }

    TlBanksApiV2.get(filterParams)
      .then((response) => {
        setTlBanks(response.data.tl_banks)
      })
      .catch(() => {
        setFieldError(name, 'Searching TL Banks error')
        setFieldTouched(name, true, false)
      })
      .finally(() => setIsLoading(false))
  }

  // The presentation of option label when dropdown is open
  const getOptionLabel = (option) => (
    <>
      <strong>{ option.bank }</strong>
      <br />
      <span>{ option.account_number }</span>
      {
        showRole && (
          <>
            <br />
            <span>{ option.role }</span>
          </>
        )
      }
      {
        showDescription && (
          <>
            <br />
            <span className='mr-3 text-capitalize'>{ option.description }</span>
          </>
        )
      }
      <hr className='my-0' />
    </>
  )

  // The custom selected option label
  const getSelectedOptionLabel = (option) => (
    <>
      <span className='mr-3'>{ option.bank }</span>
      <span className='mr-3'>{ '-' }</span>
      <span className='mr-3'>{ option.account_number }</span>
      <span className='mr-3'>{ '-' }</span>
      <span className='mr-3'>{ option.role }</span>
    </>
  )

  // handler to search sellers
  const handleSelectSearchOnChange = (event) => {
    const searchText = event.target.value
    if (searchTimeout) clearTimeout(searchTimeout)
    searchTimeout = setTimeout(() => {
      getTlBanks(searchText)
    }, 700)
  }

  return (
    <SelectSearchField
      name={ name }
      label={ label }
      placeholder='Search with Bank Name'
      dataList={ tlBanks }
      onSearchChange={ handleSelectSearchOnChange }
      getOptionLabel={ getOptionLabel }
      getSelectedOptionLabel={ getSelectedOptionLabel }
      isLoading={ isLoading }
      required={ required }
      { ...props }
    />
  )
}

TlBankSelectSearchField.propTypes    = propTypes
TlBankSelectSearchField.defaultProps = defaultProps

export default TlBankSelectSearchField
